import { render, staticRenderFns } from "./CurriculumCategory.vue?vue&type=template&id=0d3e0cca"
import script from "./CurriculumCategory.vue?vue&type=script&lang=js"
export * from "./CurriculumCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3e0cca')) {
      api.createRecord('0d3e0cca', component.options)
    } else {
      api.reload('0d3e0cca', component.options)
    }
    module.hot.accept("./CurriculumCategory.vue?vue&type=template&id=0d3e0cca", function () {
      api.rerender('0d3e0cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/CurriculumCategory.vue"
export default component.exports